// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_aXq","cls2":"SingularMentionCitationModal-cls2_URV SingularMentionCitationModal-cls1_aXq"};